/*
 * Send the shopper to the cart page after a successful add-to-cart.
 *
 * Exception: products in the Bulk Flowers collection. Bulk orders are built up a
 * bunch at a time, so bouncing to the cart after every add would break that flow.
 *
 * The theme adds to the cart over ajax from several places (product form, sticky
 * bar, product cards, buy-together, grouped products). They all go through
 * jQuery.ajax, so one global ajaxSuccess hook covers every path instead of
 * patching each call site in wpbingo.js.
 */
(function () {
	'use strict';

	var BULK_COLLECTION_HANDLE = 'bulk-flowers';

	// The form behind the most recent add-to-cart. Captured on the way down so it
	// is recorded before the theme's own submit/click handlers run.
	var lastAddToCartForm = null;

	function addToCartForm(el) {
		if (!el || !el.closest) {
			return null;
		}
		return el.closest('form[action*="/cart/add"]');
	}

	document.addEventListener('submit', function (event) {
		var form = addToCartForm(event.target);
		if (form) {
			lastAddToCartForm = form;
		}
	}, true);

	// Several add-to-cart buttons preventDefault on click and never fire submit.
	document.addEventListener('click', function (event) {
		var form = addToCartForm(event.target);
		if (form) {
			lastAddToCartForm = form;
		}
	}, true);

	function onBulkFlowersCollection() {
		// Matches locale-prefixed paths too, e.g. /en-ca/collections/bulk-flowers.
		return window.location.pathname.indexOf('/collections/' + BULK_COLLECTION_HANDLE) !== -1;
	}

	function isBulkFlowersAdd() {
		if (onBulkFlowersCollection()) {
			return true;
		}
		return !!lastAddToCartForm && lastAddToCartForm.getAttribute('data-bulk-flowers') === 'true';
	}

	if (!window.jQuery) {
		return;
	}

	jQuery(document).on('ajaxSuccess', function (event, xhr, settings) {
		var url = (settings && settings.url) || '';
		if (url.indexOf('/cart/add') === -1) {
			return;
		}

		var skipRedirect = isBulkFlowersAdd();
		lastAddToCartForm = null;

		if (skipRedirect) {
			return;
		}

		window.location.href = (window.routes && window.routes.cart_url) || '/cart';
	});
})();
